
const storeLocator = require('../storeLocator/storeLocator');
const formHelpers = require('../components/form');
const utils = require('../utils');

/**
 * Assigned Events to the StoreLocator form.
 */
function assingStoreLocatorEvents() {
    storeLocator.search();
    storeLocator.detectLocation();
    storeLocator.changeRadius();
    storeLocator.updateSelectStoreButton();
}
/**
 * Populate store finder html
 * @param {Object} target - Dom element that needs to be populated with store finder
 */
function loadStoreLocator(target) {
    $.ajax({
        url: target.data('url'),
        method: 'GET',
        success(response) {
            const storePickupMode = utils.getCookie('storePickupMode');
            if (storePickupMode === 'modal') {
                target.html(response.storesResultsHtml);
                assingStoreLocatorEvents();
                if (!$('.results').data('has-results')) {
                    $('.store-locator-no-results').show();
                }
                $('.modal-backdrop').remove();
            } else {
                $('#pickup-in-store-store-result').html(response.storesResultsHtml);
                $('#pickup-in-store-store-result').show();
                assingStoreLocatorEvents();
            }
            formHelpers.inputFocus();
        },
    });
}


/* eslint-disable no-eval */
module.exports = {

    /**
     * Hide Address Shipping
     */
    hideAddressShipping(shippingForm) {
        // hide address panel
        shippingForm.find('.shipment-selector-block,.shipping-address-block').addClass('d-none');
        shippingForm.find('.gift').prop('checked', false);

        const toggleButton = $('.toggle-switch');
        if (toggleButton.hasClass('active')) {
            toggleButton.removeClass('active');
            shippingForm.find('.gift-message-block').addClass('d-none');
        }
    },

    /**
     * Show store locator when appropriate shipping method is selected
     * @param {Object} shippingForm - DOM element that contains current shipping form
     */
    showStoreFinder(shippingForm) {
        // hide address panel
        shippingForm.find('.change-store').addClass('d-none');
        shippingForm
            .find('.pickup-in-store')
            .empty()
            .removeClass('d-none');

        loadStoreLocator(shippingForm.find('.pickup-in-store'));
    },
};
